import { gsap } from 'gsap';
import { killScroll } from "../parts/stickyslider";


export function stickycard() {
    
    var section = document.querySelector(".sticky-card-wrap");
    if (section == undefined || section == null) {
        return;
    }
    var w = jQuery(window).width();
    if (w <= 740) {
        scrollCardMobile();
    } else {
        scrollCardDesktop();
    }
   // console.log(ScrollTrigger.getAll());
}

function scrollCardDesktop() {
    if (jQuery(".sticky-card-wrap.slick-initialized").length != 0) {
        jQuery(".sticky-card-wrap").slick("unslick");
    }

    killScroll("scrollCard");
    killScroll("scrollCardPin");

    var section = document.querySelector(".sticky-card-wrap");
    var child = jQuery(section).find(".card-box");
    var childCount = child.length;
    var childHeight = child.outerHeight();

    let tl = "";

    child.each(function (index, element) {
        if (index == childCount - 1) {
            return;
        }
        var multiplier = childCount - 1 - index;
        var totalHeight = multiplier * childHeight + "px";
        var elScale = jQuery(element).find(".card-scale");
        var elOpacity = jQuery(element).find(".card-box-inner");

        tl = gsap.timeline({
            scrollTrigger: {
               // markers: true,
                id: "scrollCard",
                trigger: element,
                pin: true,
                start: "top 20%",
                end: totalHeight,
                scrub: 1,
                pinSpacing: false,
            },
        });
        tl.addLabel("card");
        tl.to(
            elScale,
            {
                y: "-50%",
                scale: "0.7",
            },
            "card"
        ).to(
            elOpacity,
            {
                opacity: 0.5,
            },
            "card"
        );
    });

    var sideElement = jQuery(".notice-content");
    var sideParent = jQuery(".middle-parts");
    var totalHeight = sideParent.outerHeight() + "px";

    let tl_2 = gsap.timeline({
        scrollTrigger: {
            //markers: true,
            id: "scrollCardPin",
            trigger: sideElement,
            pin: true,
            start: "top 20%",
            end: totalHeight + " 60%",
            scrub: 1,
            pinSpacing: false,
        },
    });
}

function scrollCardMobile() {
    var $targetElement = jQuery(".sticky-card-wrap");
    killScroll("scrollCard");
    killScroll("scrollCardPin");

    if (
        jQuery($targetElement).length != 0 &&
        jQuery(".sticky-card-wrap.slick-initialized").length == 0
    ) {
        jQuery($targetElement).slick({
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            touchThreshold: 10,
            draggable: true,
            swipeToSlide: true,
            autoplay: true,
            arrows: false,
        });        
    }
}
